<template lang="pug">
gmap-autocomplete(:options="optionsAutocomplete" @place_changed="setPlace")
  template(v-slot:input="slotProps")
    v-text-field(
      :placeholder="placeholder"
      :label="label"
      ref="input"
      v-model="search"
      v-on:listeners="slotProps.listeners"
      v-on:attrs="slotProps.attrs")
      v-btn(
        icon
        slot="append"
        x-small
        v-if="search"
        @click="clearPlace()")
        v-icon mdi-close
</template>
<script>
import { cloneDeep } from 'lodash'
export default {
  name: 'GoogleMapAutocomplete',
  props: {
    params: {
      type: Array,
      default: x => []
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    loadSearch: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      optionsAutocomplete: {
        region: 'BR',
        language: 'br',
        componentRestrictions: {
          country: 'br',
        }
      },
      search: null,
      result: null,
      paramsArr: [
        {
          key: 'log',
          gfield: 'route',
          short_name: false
        },
        {
          key: 'code',
          gfield: 'postal_code',
          short_name: false
        },
        {
          key: 'neighborhood',
          gfield: 'sublocality',
          short_name: false
        },
        {
          key: 'country',
          gfield: 'country',
          short_name: false
        },
        {
          key: 'region',
          gfield: 'administrative_area_level_1',
          short_name: false
        },
        {
          key: 'city',
          gfield: 'administrative_area_level_2',
          short_name: false
        },
        {
          key: 'number',
          gfield: 'street_number',
          short_name: false
        },
        {
          key: 'state',
          gfield: 'administrative_area_level_1',
          short_name: true
        }
      ]
    }
  },
  created () {
    if (this.params.length) {
      this.paramsArr = cloneDeep(this.params)
    }
  },
  watch: {
    result () {
      this.$emit('input', this.result)
    },
    loadSearch(value) {
      if(value) {
        this.search = value;
      }
    }
  },
  methods: {
    clearPlace () {
      this.result = null
      this.search = null
    },
    setPlace({ address_components }) {
      // The params can be received as prop to more custom results
      this.result = this.searchParams(this.paramsArr, address_components)
    },
    searchParams (params, arr) {
      try {
        const obj = {}
        for(const i in params) {
          const result = arr.filter( v => v.types.includes(params[i].gfield))
          if (result.length)
            obj[params[i].key] = !params[i].short_name? result[0].long_name || result[0].short_name : result[0].short_name
        }
        return obj
      } catch (error) {
        // vazio
      }
      return null
    }
  }
}
</script>
